// Platform language codes that are not ISO 639-1 codes.
const ISO_CODES = { ua: 'uk' };

const toIso = (code) => ISO_CODES[code] ?? code;

/**
 * Language of the interface, read from the react-i18next instance `i18n`: its resolved language, else its
 * language, else "en".
 */
export const uiLocale = (i18n) => i18n?.resolvedLanguage || i18n?.language || 'en';

/**
 * Name of the language `code` written in `locale` ("en" in "fr" gives "Anglais"), capitalised.
 * Falls back to the upper-cased code when the runtime does not know the language.
 */
export const languageName = (code, locale = 'en') => {
    try {
        const isoLocale = toIso(locale);
        const name = new Intl.DisplayNames([isoLocale], { type: 'language', fallback: 'none' }).of(toIso(code));
        if (!name) return code.toUpperCase();
        return name.charAt(0).toLocaleUpperCase(isoLocale) + name.slice(1);
    } catch {
        return code.toUpperCase();
    }
};

/**
 * `items` joined as a list in `locale` ("A, B, and C" in "en", "A, B et C" in "fr").
 * Falls back to joining them with commas when the runtime cannot format lists.
 */
export const formatList = (items, locale = 'en') => {
    try {
        return new Intl.ListFormat(toIso(locale), { type: 'conjunction' }).format(items);
    } catch {
        return items.join(', ');
    }
};
